/**
 * Audio settings — §5.2, §5.7, §14.1.
 *
 * EVERY setter here goes through `edit`, which bumps `audioEpoch`. That bump IS the
 * restart: the reconciler re-seeks the sounding ayah when the epoch changes, so a
 * settings edit replays the current verse under the new settings instead of taking
 * effect at some unpredictable point in the future.
 *
 * §5.2: `followRecitation` and `autoAdvancePage` are DISTINCT CONCEPTS and must never
 * be conflated — one moves the view, the other moves the recitation.
 */
import { DEFAULT_PLAYBACK_RATE, DEFAULT_RECITER_ID } from '@mushaf/corpus'
import type { AudioSlice, SettingsEdit } from './types'

export const createAudioSlice = (edit: SettingsEdit): AudioSlice => ({
  reciterId: DEFAULT_RECITER_ID,
  playbackRate: DEFAULT_PLAYBACK_RATE,
  followRecitation: true,
  autoAdvancePage: true,

  setReciter: (reciterId) => edit({ reciterId }),
  setPlaybackRate: (playbackRate) => edit({ playbackRate }),
  setFollowRecitation: (followRecitation) => edit({ followRecitation }),
  setAutoAdvancePage: (autoAdvancePage) => edit({ autoAdvancePage }),
})
